<template>
    <tr>
        <td class="editor-content editor-label">{{resourceLabel}}</td>
        <td class="editor-content">

            <div class="btn-group dropleft">
                <button class="btn btn-light btn-sm dropdown" type="button" data-bs-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                    {{linkLocationLabel}}
                </button>
                <div class="dropdown-menu">
                    <h6 class="dropdown-header">Pages</h6>
                    <a v-for="page in pages" class="dropdown-item" href="javascript:void(0)"
                       @click="onPageSelected(page)"
                       :class="isActivePageLink(page) ? 'active' : ''">{{page.title}}</a>

                    <div v-if="model.app.id" class="dropdown-divider"></div>
                    <h6 v-if="model.app.id" class="dropdown-header">Public Views</h6>

                    <a v-for="view in publicViews" class="dropdown-item" href="javascript:void(0)"
                       @click="onViewLinkSelected(view)"
                       :class="isActiveViewLink(view) ? 'active' : ''">{{view.name}}</a>

                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="javascript:void(0)" @click.stop="onUrlSelected()"
                       :class="selectedComponent.resourceType === 'URL' ? 'active' : ''">URL</a>
                    <div class="dropdown-divider"></div>

                    <div v-show="urlVisible" class="form-group">
                        <input type="text" class="form-control" id="urlInput" placeholder="https://"
                               v-model="selectedComponent.resource">
                    </div>
                </div>
            </div>

        </td>
    </tr>
</template>

<script>
    export default {
        name: 'WebsiteLinkProperties',
        props: {
            selectedComponent: Object,
            page: Object,
            resourceLabel: {
                type: String,
                default: 'Resource'
            }
        },
        computed: {
            linkLocationLabel() {
                return this.selectedComponent.resource ? this.selectedComponent.resource : 'select'
            },
            pages() {
                if(this.page) {
                    return this.model.website.webpages.filter(page => page.id !== this.page.id)
                }

                return this.model.website.webpages
            },
            publicViews() {
                if (!this.model.app.id) {
                    return []
                }

                let appViews = webase.managers.app.getViews()
                return appViews.filter(view => view.published ? true : false)
            },
            urlVisible() {
                return this.selectedComponent.resourceType === 'URL'
            }
        },
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        },
        methods: {
            isActivePageLink(page) {
                return this.selectedComponent.resourceType === "Page" && this.selectedComponent.resource === page.slug
            },
            onPageSelected(page) {
                this.selectedComponent.resourceType = "Page"
                this.selectedComponent.resource = page.slug
            },
            isActiveViewLink(view) {
                return this.selectedComponent.resourceType === "View" && this.selectedComponent.resource === view.id
            },
            onViewLinkSelected(view) {
                this.selectedComponent.resourceType = "View"
                this.selectedComponent.resource = view.id
            },
            onUrlSelected() {
                this.selectedComponent.resourceType = "URL"
                this.selectedComponent.resource = ''
            }
        }
    }
</script>
